<template>
  <div>
    <j-modal title="distributionTenant"
             width="40%"
             :visible="visible"
             @ok="handleOk"
             @cancel="close">
      <a-select v-model="tenantIdList"
                mode="multiple"
                show-search
                :filter-option="filterOption"
                option-filter-prop="children"
                style="width: 100%">
        <a-select-option v-for="item in tenantList" :key="item.id" :value="item.id">
          {{ item.name }}
        </a-select-option>
      </a-select>
    </j-modal>
  </div>
</template>

<script>
import { tenantDistributionSave, tenantList } from '@api/api'

export default {
  name: 'DistributionTenantModal',
  title: '分配租户模态框',
  data() {
    return {
      visible: false,
      // 已有租户ids
      tenantIdList: [],
      // 租户下拉框选项
      tenantList: []
    }
  },
  methods: {
    // 打开模态框
    openModal(data = {}) {
      this.getTenantList()
      this.visible = true
      if (!data.relTenantIds) return
      this.tenantIdList = data.relTenantIds.toString()
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[ 0 ].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    handleOk() {
      tenantDistributionSave(params).then(res => {
        this.$message.success(res.message)
        this.$emit('ok')
        this.close()
      })
    },
    close() {
      this.visible = false
    },
    // 获取所有租户
    getTenantList() {
      let params = {
        pageNo: 1,
        pageSize: 100000,
        status: 1
      }
      tenantList(params).then(res => {
        this.tenantList = res.result.records
      })
    }
  }
}
</script>